import { IConfig, IConfigId } from '../twamp/types';
import { HighchartsColorCodes } from '@nrwl/common-lib';

// config.ts

// config.ts
export const TWAMP_QUERY_CONFIG: IConfig = {
  id: IConfigId.TwampConfig,
  ref: {
    id: 1,
    uid: 'activetest-truespeed-throughput-chart'
  },
  widgetConfig: [
    {
      title: 'Frame Loss for <<Flow Name>>',
      type: 'line',
      options: {
        showTooltipTotal: false,
        displayUnit: 'percentage',
        timeUnit: 'percentage',
        conversionUnits: ['%'],
        connectNulls: false,
        showInLegend: true,
        height: 300,
        useNamedSerie: true,
        disableTopCrosshairLabel: true,
        series: [
          {
            name: 'SLA',
            fieldName: 'SLA',
            color: HighchartsColorCodes.TEA_OLIVE,
            type: 'areaspline',
            visible: true,
            showInY1731: true
          },
          {
            name: 'Near-Far FLR(%)',
            fieldName: 'FLR 1way Avg N->F',
            color: HighchartsColorCodes.OCEAN_BLUE,
            type: 'line',
            visible: true,
            showInY1731: true
          },
          {
            name: 'Far-Near FLR(%)',
            fieldName: 'FLR 1way Avg F->N',
            color: HighchartsColorCodes.DODGER_BLUE,
            type: 'line',
            visible: true,
            showInY1731: true
          },
          {
            name: 'Out of Sequence Packets',
            fieldName: 'OOS Count N->F',
            color: HighchartsColorCodes.ATLANTIS,
            type: 'line',
            visible: true,
            showInY1731: false
          },
          {
            name: 'Duplicate Packets',
            fieldName: 'Dup Count N->F',
            color: HighchartsColorCodes.TAPA,
            type: 'line',
            visible: true,
            showInY1731: false
          },
          {
            name: 'DSCP Mismatch',
            fieldName: 'DSCP Mismatch',
            color: HighchartsColorCodes.LAKE,
            type: 'line',
            visible: true,
            showInY1731: false
          }
        ],
        override: {
          yAxis: [
            {
              title: {
                text: 'Packet Loss'
              }
            }
          ]
        }
      }
    },
    {
      title: 'Frame Delay for <<Flow Name>>',
      type: 'line',
      options: {
        showTooltipTotal: false,
        displayUnit: 'time',
        timeUnit: 'milliseconds',
        conversionUnits: ['ns', 'μs', 'ms', 's', 'min', 'h', 'd'],
        connectNulls: false,
        showInLegend: true,
        height: 300,
        useNamedSerie: true,
        disableTopCrosshairLabel: true,
        series: [
          {
            name: 'SLA',
            fieldName: 'SLA',
            color: HighchartsColorCodes.TEA_OLIVE,
            type: 'areaspline',
            visible: true
          },
          {
            name: '2-way delay (ms)',
            fieldName: 'FD 2way Avg',
            color: HighchartsColorCodes.OCEAN_BLUE,
            type: 'line',
            visible: true
          },
          {
            name: 'Near-far Delay (ms)',
            fieldName: 'FD 1way Avg N->F',
            color: HighchartsColorCodes.DODGER_BLUE,
            type: 'line',
            visible: true
          },
          {
            name: 'Far-Near Delay (ms)',
            fieldName: 'FD 1way Avg F->N',
            color: HighchartsColorCodes.ATLANTIS,
            type: 'line',
            visible: true
          }
        ],
        override: {
          yAxis: [
            {
              title: {
                text: 'Packet Delay'
              }
            }
          ]
        }
      }
    },
    {
      title: 'Frame Delay Variation for <<Flow Name>>',
      type: 'line',
      options: {
        showTooltipTotal: false,
        displayUnit: 'time',
        timeUnit: 'milliseconds',
        conversionUnits: ['ns', 'μs', 'ms', 's', 'min', 'h', 'd'],
        connectNulls: false,
        showInLegend: true,
        height: 300,
        useNamedSerie: true,
        disableTopCrosshairLabel: true,
        series: [
          {
            name: 'SLA',
            fieldName: 'SLA',
            color: HighchartsColorCodes.TEA_OLIVE,
            type: 'areaspline',
            visible: true
          },
          {
            name: '2-way FDV (ms)',
            fieldName: 'IFDV 2way Avg',
            color: HighchartsColorCodes.OCEAN_BLUE,
            type: 'line',
            visible: true
          },
          {
            name: 'Near-far FDV (ms)',
            fieldName: 'IFDV 1way Avg N->F',
            color: HighchartsColorCodes.DODGER_BLUE,
            type: 'line',
            visible: true
          },
          {
            name: 'Far-near FDV (ms)',
            fieldName: 'IFDV 1way Avg F->N',
            color: HighchartsColorCodes.ATLANTIS,
            type: 'line',
            visible: true
          }
        ],
        override: {
          yAxis: [
            {
              title: {
                text: 'Packet Variation'
              }
            }
          ]
        }
      }
    },
    {
      title: 'MOS for <<Flow Name>>',
      type: 'line',
      options: {
        showTooltipTotal: false,
        conversionUnits: [''],
        displayUnit: 'fixed',
        connectNulls: false,
        showInLegend: true,
        height: 300,
        useNamedSerie: true,
        disableTopCrosshairLabel: true,
        series: [
          {
            name: 'SLA',
            fieldName: 'SLA',
            color: HighchartsColorCodes.TEA_OLIVE,
            type: 'areaspline',
            visible: true
          },
          {
            name: '2-way',
            fieldName: 'QM 2way MOS',
            color: HighchartsColorCodes.OCEAN_BLUE,
            type: 'line',
            visible: true
          }
        ],
        override: {
          yAxis: [
            {
              title: {
                text: 'MOS'
              }
            }
          ]
        }
      }
    }
  ],
  constants: { time_zone: 'UTC' }
};
